/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import Image from './ImageLoader'
import BotImageLoader from './BotImageLoader'

const ImageLoader = ({ isBot, ...props }) => {
  if (isBot) return <BotImageLoader {...props} />
  return <Image {...props} />
}

export { ImageLoader }
